export const Prices = [
  {
    _id: 0,
    name: "₹ 0 to 249",
    array: [0, 249],
  },
  {
    _id: 1,
    name: "₹ 250 to 349",
    array: [250, 349],
  },
  {
    _id: 2,
    name: "₹ 350 to 449",
    array: [350, 449],
  },
  {
    _id: 3,
    name: "₹ 450 to 549",
    array: [450, 549],
  },
  {
    _id: 4,
    name: "₹ 550 to 649",
    array: [550, 649],
  },
  {
    _id: 5,
    name: "₹ 650 to 749",
    array: [650, 749],
  },
  {
    _id: 6,
    name: "₹ 750 to 849",
    array: [750, 849],
  },
  {
    _id: 7,
    name: "₹ 850 to 949",
    array: [850, 999],
  },
  {
    _id: 8,
    name: "₹ 1000 or above",
    array: [1000, 9999],
  },
];
